import React from 'react'
const EmailsOptions = ({ options }) => {
  return (
    <div className="emails__options">
      {options.map((option) => option.enabled && (
        <button className="emails__options-btn" key={option.id}
          onClick={option.action}
        >{option.label}</button>
      ))}
    </div>
  )
}

export default EmailsOptions